/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Manages the users informations and listings
 */
import { Box } from "@mui/material";
import React, { useState } from "react";

import { UsersList } from "./UsersList";
import { useFetchData } from "../../components/hooks/useFetchData";

const UsersPage = () => {
  const [minLoading, setMinLoading] = useState(true);
  const [userList, setUserList] = useState([]);

  const { fetchData, loading } = useFetchData();

  const getAllUsers = async () => {
    const result = await fetchData("getusers");
    if (result?.code === 200) {
      setUserList(result.data);
    }
  };

  React.useEffect(() => {
    getAllUsers();
    const minLoadingTimer = setTimeout(() => {
      setMinLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading = minLoading || loading["getusers"];

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <UsersList users={userList} isLoading={isLoading} />
      </Box>
    </>
  );
};
export default UsersPage;
